import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)};

  &:first-child {
    margin-top: 0;
  }
`;
